import Shopping from './Shopping';
import Cart from './Cart';
import Catalog from './Catalog';
import ProductDetail from './ProductDetail';

export default Shopping;
export { Cart, Catalog, ProductDetail };
